import axios from 'axios'

// 获取图片资源
export function getImage(type) {
    return axios({
        url: `/file/getImage`,
        method: 'get',
        params: {
            type: type
        }
    })
}

// 获取文本资源
export function getTxt(type) {
    return axios({
        url: `/file/getTxt`,
        method: 'get',
        params: {
            type: type
        }
    })
}
